var Acr = Acr || {};

Acr.MultiAccordion = function () {

  var $multiAccordion;
  var $multiAccordionLinks;
  var $multiAccordionBodies;
  var resizeWindow;
  const multiAccordionBody = '.js-multi-accordion-body';
  const multiAccordionLink = '.js-multi-accordion-link';
  const multiAccordionActive = 'acr-multi-accordion__section--active';
  const multiAccordionLook1 = 'acr-multi-accordion--look-1';

  function initSelectors(element) {
    $multiAccordion = element;
    $multiAccordionBodies = $multiAccordion.querySelectorAll(multiAccordionBody);
    $multiAccordionLinks = $multiAccordion.querySelectorAll(multiAccordionLink);
  }

  // Start video function when the accordion opens up
  function startVideo(video) {
    if (video) {
      video.play();
    }
  }

  // Stop video function when the accorion closes up
  function stopVideo(video) {
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  }

  function onClickMultiAccordion() {
    event.preventDefault();
    const accordionSection = this.parentElement.parentElement; // Select acr-multi-accordion__section

    if (accordionSection.classList.contains(multiAccordionActive)) {
      slideUp(accordionSection);
      this.setAttribute('aria-expanded', false);
    } else {
      // Check if another accordion is open for default look
      if (!$multiAccordion.classList.contains(multiAccordionLook1)) {
        var accordionContainer = accordionSection.parentElement;
        var currentActive = accordionContainer.querySelector('.' + multiAccordionActive);
        if (currentActive) {
          slideUp(currentActive);
        }
      }

      slideDown(accordionSection);
      this.setAttribute('aria-expanded', true);
    }
  }

  // Slide up function, close up the accordion
  function slideUp(accordionSection) {
    const accordionBody = accordionSection.querySelector(multiAccordionBody);
    const accordionVideo = accordionSection.querySelector('video');

    accordionBody.style.height = accordionBody.offsetHeight + 'px';
    /* eslint-disable no-unused-expressions */
    accordionBody.offsetHeight;
    /* eslint-enable no-unused-expressions */
    accordionBody.style.removeProperty('height');
    accordionSection.classList.remove(multiAccordionActive);
    // stop video
    stopVideo(accordionVideo);
  }

  // Slide down function, open up the accordion
  function slideDown(accordionSection) {
    const accordionBody = accordionSection.querySelector(multiAccordionBody);
    const accordionVideo = accordionSection.querySelector('video');

    accordionBody.style.height = 0;
    /* eslint-disable no-unused-expressions */
    accordionBody.offsetHeight;
    /* eslint-enable no-unused-expressions */
    accordionBody.style.height = accordionBody.scrollHeight + 'px';
    accordionSection.classList.add(multiAccordionActive);
    // start video
    startVideo(accordionVideo);
  }

  // Callback function when resizing occurs on desktop
  function onResizeMultiAccordion() {
    // If there's a timer, cancel it
    if (resizeWindow) {
      window.cancelAnimationFrame(resizeWindow);
    }

    // Setup the new requestAnimationFrame()
    resizeWindow = window.requestAnimationFrame(function () {
      $multiAccordionBodies.forEach(function (accordionBody) {
        accordionBody.style.removeProperty('height');
      });
    });
  }

  function bindEvents() {
    // Attachment of click events for each of the accordions
    $multiAccordionLinks.forEach(function (link) {
      link.addEventListener('click', onClickMultiAccordion);
    });

    window.addEventListener('resize', onResizeMultiAccordion);
  }

  function init(element) {
    Utility = window.Utility || {};
    initSelectors(element);
    bindEvents();
  }

  return {
    init: init,
  };

};
